<div [formGroup]="form" class="address-form-container">
  <ng-container *ngIf="street">
    <ng-container *ngIf="managePostal">
      <div class="address-section-header">
        <h3 class="section-title">
          {{ titlePhysicalAddress.length > 0 ? titlePhysicalAddress : 'Dirección Física' }}
        </h3>
      </div>
    </ng-container>

    <div class="form-row full-width">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">home</mat-icon>
          Dirección Física
        </mat-label>
        <input matInput formControlName="StreetAddress" [required]="this.isRequired">
        <mat-error *ngIf="form.controls['StreetAddress'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row full-width">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">home</mat-icon>
          Dirección Física línea 2
        </mat-label>
        <input matInput formControlName="StreetAddress2">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">markunread_mailbox</mat-icon>
          Código Postal
        </mat-label>
        <input mask="00000" matInput formControlName="PostalCode" [required]="this.isRequired">
        <mat-error *ngIf="form.controls['PostalCode'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">public</mat-icon>
          País
        </mat-label>
        <mat-select formControlName="Country" [required]="this.isRequired">
          <mat-option [value]="">Seleccione</mat-option>
          <mat-option (click)="onCountryChange('City', 'State','MunicipioStreet', item.value)"
            *ngFor="let item of lookupService.countries" [value]="item.value">{{item.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['Country'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row full-width">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">location_city</mat-icon>
          Municipio
        </mat-label>
        <mat-select formControlName="MunicipioStreet">
          <mat-option [value]="">Seleccione</mat-option>
          <mat-option *ngFor="let item of lookupService.cities" [value]="item.value">{{item.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['MunicipioStreet'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">location_on</mat-icon>
          Estado
        </mat-label>
        <mat-select formControlName="State">
          <mat-option [value]="">Seleccione</mat-option>
          <mat-option *ngFor="let item of lookupService.states" [value]="item.value">{{item.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['State'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">location_city</mat-icon>
          Ciudad
        </mat-label>
        <input matInput formControlName="City">
        <mat-error *ngIf="form.controls['City'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="checkbox-section" *ngIf="managePostal==true">
      <mat-checkbox formControlName="postalAsStreet" (change)="patchSameAsPhysical()">
        <span class="checkbox-label">Dirección postal igual a física</span>
      </mat-checkbox>
    </div>

  </ng-container>

  <ng-container *ngIf="this.form.controls.postalAsStreet.value == false && managePostal==true">
    <ng-container *ngIf="street">
      <div class="address-section-header">
        <h3 class="section-title">
          {{ titlePostalAddress.length > 0 ? titlePostalAddress : 'Dirección Postal' }}
        </h3>
      </div>
    </ng-container>

    <div class="form-row full-width">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">home</mat-icon>
          Dirección Postal
        </mat-label>
        <input matInput formControlName="PostalAddress"
          [required]="this.form.controls.postalAsStreet.value==false && this.isRequired">
        <mat-error *ngIf="form.controls['PostalAddress'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row full-width">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">home</mat-icon>
          Dirección Postal línea 2
        </mat-label>
        <input matInput formControlName="PostalAddress2">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">markunread_mailbox</mat-icon>
          Código Postal
        </mat-label>
        <input mask="00000" matInput formControlName="PPostalCode"
          [required]="this.form.controls.postalAsStreet.value==false && this.isRequired">
        <mat-error *ngIf="form.controls['PPostalCode'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">public</mat-icon>
          País
        </mat-label>
        <mat-select formControlName="CountryPostal"
          [required]="this.form.controls.postalAsStreet.value==false && this.isRequired">
          <mat-option [value]="">Seleccione</mat-option>
          <mat-option (click)="onCountryChange('CityPostal', 'StatePostal','MunicipioPostal', item.value)"
            *ngFor="let item of lookupService.countries" [value]="item.value">{{item.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['CountryPostal'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row full-width">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">location_city</mat-icon>
          Municipio
        </mat-label>
        <mat-select formControlName="MunicipioPostal">
          <mat-option [value]="">Seleccione</mat-option>
          <mat-option *ngFor="let muni of lookupService.cities" [value]="muni.value">{{muni.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['MunicipioPostal'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">location_on</mat-icon>
          Estado
        </mat-label>
        <mat-select formControlName="StatePostal">
          <mat-option [value]="">Seleccione</mat-option>
          <mat-option *ngFor="let item of lookupService.states" [value]="item.value">{{item.label}}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls['StatePostal'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>
          <mat-icon class="field-icon">location_city</mat-icon>
          Ciudad
        </mat-label>
        <input matInput formControlName="CityPostal">
        <mat-error *ngIf="form.controls['CityPostal'].hasError('required')">
          Campo requerido
        </mat-error>
      </mat-form-field>
    </div>
  </ng-container>
</div>
